module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_kimono@2x-41ba2bf0d6462afd1b55850ef92e7585.webp";